import { ref, Ref } from 'vue'
import { AuthData, PreAuthData } from './authTypes'
import { Route } from '@/composables/useRouter'

export interface AuthState {
  loadingRef: Ref<boolean>
  preAuthData: Ref<PreAuthData>
  authData: Ref<AuthData>
  errorData: Ref<any>
  nextUrlData: Ref<Route>
}

export function createInitialState(): AuthState {
  return {
    loadingRef: ref(false),
    preAuthData: ref({} as PreAuthData),
    authData: ref({} as AuthData),
    errorData: ref(null),
    nextUrlData: ref({} as Route),
  }
}
